import { useMemo } from 'react'
import camelCase from 'lodash/camelCase'
import { useAdsConfigQuery } from '@mwxltd/flix-api-client'
import { useMediaIs } from '../../../style/media.js'
import { useSkippedListAds } from './ListAdInsertionContext.js'
import { insertListAds } from './insertListAds.js'

export const useNestedListAdInsertion = ({ list, skip }) => {
  const sm = useMediaIs('sm')

  const { data } = useAdsConfigQuery()

  const adsConfig = data?.listAdTemplates
  const adConfig = list && adsConfig?.[camelCase(list.slug)]
  const adTemplate = adConfig?.adTemplate
  const skippedAds = useSkippedListAds(
    adTemplate?.zone,
    (sm ? adTemplate?.placement : adTemplate?.placementMobile) ??
      adTemplate?.placement ??
      adTemplate?.placementMobile,
  )

  return useMemo(() => {
    if (!list || !adConfig || skip) return list

    const { listFirst, listInterval } = adConfig

    let index = 0
    const items = []

    items.push(
      ...list.items.slice(0, listFirst),
      insertListAds({ list: list.items[listFirst], adConfig, skippedAds, listIndex: index++ }),
      ...list.items.slice(listFirst + 1, listFirst + 2),
    )

    if (!listInterval) {
      items.push(...list.items.slice(listFirst + 2))
    } else {
      for (let i = listFirst + 2; i < list.items.length; i++) {
        if ((i - listFirst) % listInterval === 0) {
          items.push(
            insertListAds({ list: list.items[i], adConfig, skippedAds, listIndex: index++ }),
          )
        } else {
          items.push(list.items[i])
        }
      }
    }

    return { ...list, items }
  }, [list, adConfig, skippedAds, skip])
}
